import { useContext } from "react";
import { CollapseDrawerContext } from "../contexts/CollapseDrawerContext";

// ----------------------------------------------------------------------

const useCollapseDrawer = () => useContext(CollapseDrawerContext);

export default useCollapseDrawer;
